import React, { useEffect } from 'react';
import AppState, { POPUPS } from '../../js/AppState';

import Texts from 'react-sdk/Texts';
import Button from '../shared/Button/Button';
import Footer from '../shared/Footer/Footer';
import classes from './ScreenEndGame.module.css';


import PopupsManager from 'react-sdk/PopupsManager';

/*import illu_landscape from './assets/header_landscape.png';*/
import illu_portrait from './assets/header_portrait.png';
import illu_landscape from './assets/left-ending-page-content.png';

import logo from './assets/logo.png';
import Analytics from 'react-sdk/Vertx/Analytics';

const ScreenEndGame = () => {

  const win = AppState.lp_api.args?.win ?? true
  const elapsedTimeSec = AppState.lp_api.args?.elapsedTimeSec ?? 0

  const btnScale = AppState.orientation === "portrait" ? 1.2 : 0.8

  useEffect(() => {
    console.log("===== Datas transmises par le jeu")
    console.log(AppState.lp_api.args)
    console.log("===== ")

    Analytics.scoreEvents("game-win", win ? "1" : "0")
    Analytics.scoreEvents("game-timer-elapsed", elapsedTimeSec.toString())
  }, []);

  function openReglesTirage(e){
    e.preventDefault()
    PopupsManager.open(POPUPS.REGLES_TIRAGE, { data: "data"})
  };

  return (
    <div className={`${classes.ScreenEndGame} ${classes[AppState.orientation]} ${win ? classes.Win:''}`}>
      <div className={classes.Page}>
        {AppState.orientation === "portrait" && <div className={classes.IllustrationContainer}>
          <img src={AppState.orientation === "portrait" ? illu_portrait : illu_landscape} />
        </div>}

        <div className={classes.ContentContainer} >
          <div className={classes.LogoBlock}>
            <div className={classes.TitleVictory}>{Texts.get(win ? "endpage-title-win" : "endpage-title-fail")}</div>
            <img className={classes.Logo} src={logo} />
          </div>
          <div className={classes.TextsBlock}>
            <div className={classes.Descr1} dangerouslySetInnerHTML={{ __html: Texts.get(win ? "endpage-description-win" : "endpage-description-fail") }} />
            {win && <div className={classes.Descr2} dangerouslySetInnerHTML={{ __html: Texts.get("endpage-preuve") }}/>}
          </div>

          <div className={classes.ButtonsBlock}>
            <div className={classes.Buttons}>
            {!win &&
            <Button scale={ btnScale } external={false} onClick={() => window.location.reload()}>
              {Texts.get("endpage-replay-game-btn")}
            </Button>}
            {win &&
              <Button scale={ btnScale } external={true} onClick={() => AppState.openLink(Texts.get("endpage-tirage-sort-url"))}>
                {Texts.get(`endpage-tirage-sort-${AppState.orientation === "portrait" ? "portrait" : "landscape"}-btn`)}
              </Button>}
              </div>
            {/*<a href={ Texts.get("homepage-reglement-lien") } target="_blank" rel="noreferrer">{ Texts.get("homepage-reglement-text") }</a>*/}
            <a href="#"  onClick={openReglesTirage}>{ Texts.get("homepage-reglement-text") }</a>
          </div>
        </div>
        {AppState.orientation !== "portrait" && <div className={classes.IllustrationContainer}>
          <img src={AppState.orientation === "portrait" ? illu_portrait : illu_landscape} />
        </div>}
      </div>
      <Footer />
    </div>
  );
};


export default ScreenEndGame;
